import { render, staticRenderFns } from "./management-account-list.vue?vue&type=template&id=76b90d1f&"
import script from "./management-account-list.vue?vue&type=script&lang=js&"
export * from "./management-account-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports